import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportCard } from 'projects/app-misc/src/app/modules/punch-time-widget/data/report-data/report-card';

@Component({
    selector: 'app-map-marker-dialog',
    templateUrl: './map-marker-dialog.component.html',
    styleUrls: ['./map-marker-dialog.component.scss']
})
export class MapMarkerDialogComponent implements OnInit {

    latitude: number;
    longitude: number;

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: {
            lat: number,
            long: number
        }) {
        this.latitude = data.lat;
        this.longitude = data.long;
    }

    ngOnInit(): void {
    }

}
